import { ContentTypeModel } from './content-type.model';
import { WorkModel } from './work.model';
import { FSKModel } from './fsk.model';
import { FSKIndexModel } from './fsk-index.model';

/**
 * Created by vsliwka on 03/08/2017.
 */
export class EditorialContentModel {
  public id: number;
  public episodeId: number;
  public contentType: ContentTypeModel;
  public work: WorkModel;
  public number: string;
  public diffusionNum: string;
  public film24Duration: string;
  public film25Duration: string;
  public duration: string;
  public state: boolean;
  public descriptionTitle: string;
  public timeLineVersionName: string;
  public fsks: FSKModel[];
  public fsksIndex: FSKIndexModel[];
  constructor() {
    this.contentType = new ContentTypeModel();
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
